import { katTranslator } from '../../shared/i18n';

const strings = {
  'kat-panel-close': {
    'en-US': 'close',
  },
  'kat-panel-dialog-label': {
    'en-US': 'Feedback form',
  },
};

export default katTranslator(strings);
